import {DocumentTemplateAPI} from "../api/DocumentTemplateAPI";
import {RsDocumentTemplate} from "../api/dto/RsDocumentTemplate";

export class DocumentTemplateService {

    private static instance: DocumentTemplateService;
    private documentTemplateApi: DocumentTemplateAPI;

    private constructor() {
        this.documentTemplateApi = new DocumentTemplateAPI();
    }

    async retrieveDocumentTemplateByGroup(groupId: string, verificationId: string): Promise<RsDocumentTemplate[]> {
        return await this.documentTemplateApi.retrieveDocumentTemplateByGroup(groupId, verificationId);
    }

    static getInstance(): DocumentTemplateService {
        if (!this.instance) {
            this.instance = new DocumentTemplateService();
        }
        return this.instance;
    }

}